import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, FormGroup, Label, Input } from 'reactstrap';
import { PropertiesList } from '../../models/propertyModel';
import { getBrokerListInfoEndpoint } from '../../services/brokerService';
import useCallApiAndLoad from '../../../../hooks/useCallApiAndLoad';

import useAuth from '../../../../hooks/useAuth';

interface Props {
  isOpen: boolean;
  toggle: () => void;
  brokerProperty: PropertiesList | null;
  setBrokerProperty: (property: PropertiesList | null) => void;
  onSave: (editableInfo: any) => Promise<void>;
  areaCodes: any[];
}

const EditBrokerModal: React.FC<Props> = ({
  isOpen,
  toggle,
  brokerProperty,
  setBrokerProperty,
  onSave,
  areaCodes,
}) => {
  interface BrokerForm {
    name: string;
    email: string;
    area_code: string;
    phone: string;
    broker_id?: string;
  }

  const [form, setForm] = React.useState<BrokerForm>({
    name: '',
    broker_id: '',
    email: '',
    area_code: '',
    phone: '',
  });

  const { callEndpoint } = useCallApiAndLoad();
  const [brokerOptions, setBrokerOptions] = React.useState<{ label: string; value: string }[]>([]);
  const { getAuthToken } = useAuth();
  const token = getAuthToken();
  const [brokerOptionsRaw, setBrokerOptionsRaw] = React.useState<any[]>([]);

  React.useEffect(() => {
    setForm({
      name: brokerProperty?.brokerInfo?.name || '',
      email: brokerProperty?.brokerInfo?.email || '',
      area_code: brokerProperty?.brokerInfo?.area_code || '',
      phone: brokerProperty?.brokerInfo?.phone || '',
      //broker_id: brokerProperty?.landlordInfo?.broker_id || '',
    });
  }, [brokerProperty]);

  React.useEffect(() => {
    const fetchBrokers = async () => {
      const { data } = await callEndpoint(getBrokerListInfoEndpoint(token));
      if (Array.isArray(data?.data)) {
        //console.log('Broker list data:', data.data);
        setBrokerOptions(
          data.data.map((broker: any) => ({
            label: `${broker.first_name} ${broker.last_name}`,
            value: broker.broker_id,
          }))
        );
        setBrokerOptionsRaw(data.data);
      }
    };
    fetchBrokers();
  }, [token]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSave = async () => {
    await onSave(form);
    toggle();
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>Editar broker</ModalHeader>
      <ModalBody>
        {/* Select de broker al inicio */}
        <FormGroup>
          <Label>Broker</Label>
          <Input
            type="select"
            name="broker_id"
            value={form.broker_id || ''}
            onChange={e => {
              const selectedId = e.target.value;
              const selectedBroker = brokerOptions.find(b => b.value === selectedId);
              // Busca el objeto completo en la lista original (data.data)
              const fullBroker = selectedId
                ? brokerOptionsRaw.find(b => b.broker_id === selectedId)
                : null;
              setForm({
                ...form,
                broker_id: selectedId,
                name: fullBroker ? `${fullBroker.first_name} ${fullBroker.last_name}` : '',
                email: fullBroker?.email || '',
                phone: fullBroker?.phone || '',
              });
            }}
          >
            <option value="">Selecciona un broker</option>
            {brokerOptions.map(broker => (
              <option key={broker.value} value={broker.value}>{broker.label}</option>
            ))}
          </Input>
        </FormGroup>
        <FormGroup>
          <Label>Nombre</Label>
          <Input name="name" value={form.name} onChange={handleChange} />
        </FormGroup>
        <FormGroup>
          <Label>Email</Label>
          <Input name="email" value={form.email} onChange={handleChange} />
        </FormGroup>
        <FormGroup>
          <Label>Teléfono</Label>
          <Input name="phone" value={form.phone} onChange={handleChange} />
        </FormGroup>
        
    
        
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={handleSave}>Guardar</Button>
        <Button color="secondary" onClick={toggle}>Cancelar</Button>
      </ModalFooter>
    </Modal>
  );
};

export default EditBrokerModal;